import renderApp from 'render.default';

import { Platform } from 'platforms';

import applicationConfig from './core/config/local';
import { importTheme } from './ui/styles/async-loader';
import { importAssets } from './ui/assets/utils';
import { importLocales } from './ui/i18n/async-loader';

const platform = applicationConfig.platform as Platform;

async function main() {
  const platformTheme = await importTheme(platform);
  const platformImages = await importAssets(platform);
  const platformLocales = await importLocales(platform);
  renderApp({
    initialPlatform: platform,
    initialTheme: platformTheme,
    initialLocales: platformLocales,
    initialImages: platformImages,
  });
}

main();
